"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var useField_1 = require("../../hooks/useField");
var calendar_1 = require("../../icons/calendar");
var common_1 = require("./common");
var ErrorMessage_1 = __importDefault(require("./common/ErrorMessage"));
var Wrapper = (0, styled_components_1.default)(common_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n  flex-shrink: ", ";\n"], ["\n  position: relative;\n  overflow: hidden;\n  flex-shrink: ", ";\n"])), function (props) { return (props.shrink ? 1 : 0); });
var FieldText = (0, styled_components_1.default)(common_1.Placeholder)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  right: ", "px;\n  ", "\n"], ["\n  right: ", "px;\n  ", "\n"])), common_1.fieldHeight, function (p) { return (p.$hasValue ? "opacity: 1;" : ""); });
var HiddenInput = (0, styled_components_1.default)(common_1.TextInput)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  opacity: 0;\n"], ["\n  opacity: 0;\n"])));
var DateField = function (props) {
    var label = props.label, disabled = props.disabled, shrink = props.shrink, background = props.background, min = props.min, max = props.max, formatDate = props.formatDate;
    var _a = (0, useField_1.useField)(props), field = _a[0], meta = _a[1];
    var error = meta.error, touched = meta.touched;
    var showError = Boolean(error && touched);
    var ref = react_1.default.useRef(null);
    var text = field.value
        ? formatDate
            ? formatDate(field.value)
            : field.value
        : label;
    var textEl = (react_1.default.createElement(FieldText, { "$hasValue": Boolean(field.value) },
        react_1.default.createElement("span", null, text)));
    var handlePicker = function () {
        var curr = ref.current;
        if (curr) {
            curr.showPicker();
        }
    };
    var inputEl = (react_1.default.createElement(HiddenInput, __assign({ ref: ref }, field, {
        disabled: disabled,
        min: min,
        max: max,
        type: "date",
        onFocus: handlePicker,
        onClick: handlePicker
    })));
    var iconEl = (react_1.default.createElement(common_1.IconWrapper, { pointerEvents: "none" },
        react_1.default.createElement(calendar_1.CalendarM, null)));
    var lineEl = disabled ? null : react_1.default.createElement(common_1.Line, { hasError: showError });
    var errorEl = showError ? react_1.default.createElement(ErrorMessage_1.default, { children: error }) : null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Wrapper, { shrink: shrink, background: background },
            textEl,
            inputEl,
            iconEl,
            lineEl),
        errorEl));
};
exports.default = DateField;
var templateObject_1, templateObject_2, templateObject_3;
